import { memo } from 'react';
import { ModalHeader } from 'core/common/ui/ui-kit';
import { PaymentOrderDescription } from 'core/payments/entities';
import PaymentResign from '../PaymentResign';
import { ModalStyled } from './styled';

type PaymentResignDialogProps = {
  isOpen?: boolean;
  onSucceed?: (data: { order?: PaymentOrderDescription }) => void;
  onClose: () => void;
};

const PaymentResignDialog = ({ isOpen = false, onSucceed, onClose }: PaymentResignDialogProps) => {
  return (
    <ModalStyled open={isOpen}>
      <>
        <ModalHeader onClose={onClose} />
        <PaymentResign onSuccess={onSucceed} />
      </>
    </ModalStyled>
  );
};

export default memo(PaymentResignDialog);
